export default __webpack_public_path__ + "static/media/m_engineering_card24_1.35b5ac11.png";